<template>
    <option value="site">site</option>
    <option value="node">node</option>
</template>
